import { requireRoute } from "@/auth/guard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/analytics")({
  beforeLoad: ({ context }) => requireRoute(context, "/analytics"),
});
